import dayjs from 'dayjs'
import Vue from 'vue'

Vue.prototype.$date = dayjs
